import React from 'react'

const PlusMinus = props => {
    const invert = props.inverted
    return (
        <div className={`plus-minus${invert ? ' inverted' : ''}`}>
            <span />
            <span />
        </div>
    )
}

export default PlusMinus
